import React from 'react';
import eventManager from '@alife/scc-event-manager/event-manager';
import { Balloon } from '@alifd/next';
import './index.scss';

export default function Index(props) {
  const { certificateTest, i18n, certification = {} } = props;

  if (certificateTest !== 'certificate_high') return null;

  const { certType, certificationInfo } = certification;

  const handClick = (e, certIndex) => {
    e.preventDefault();
    window.goldlog &&
      window.goldlog.record(
        '/sc.6.pc.detail.certificate',
        'CLK',
        `type=${certType}`,
        'GET',
      );
    eventManager.trigger('ON_DETAIL_CERTIFICATION_CLICK', {
      certType,
      certIndex,
    });
  };

  const renderMore = () => {
    return (
      <a href="#" onClick={handClick}>
        {i18n['benefits.more']}
      </a>
    );
  };

  // 曝光打点
  if (certificateTest) {
    window.goldlog &&
      window.goldlog.record(
        '/sc.6.pc.detail.certificate',
        'EXP',
        'type=Show',
        'GET',
      );
  }

  return (
    certificateTest && (
      <div className="certificate-list">
        {certType === 'PRODUCT' && (
          <div className="certificate-item">
            {certificationInfo.slice(0, 5).map((item, index) => (
              <Balloon
                afterClose={() => {
                  window.goldlog &&
                    window.goldlog.record(
                      '/sc.6.pc.detail.certificate',
                      'CLK',
                      'type=Hover',
                      'GET',
                    );
                }}
                trigger={
                  <img
                    onClick={e => handClick(e, index)}
                    key={item.name}
                    src={item.logoUrl}
                  />
                }
                align="tr"
              >
                {item.introduction}
              </Balloon>
            ))}
            {renderMore()}
          </div>
        )}
        {certType === 'INSPECTION_REPORT' &&
          certificationInfo.slice(0, 1).map(item => (
            <div className="certificate-item" key={item.sellingPoint}>
              <img
                className="certifacate"
                onClick={handClick}
                src="//img.alicdn.com/imgextra/i1/O1CN01nVcKPh1xxd2w77tv7_!!6000000006510-2-tps-28-32.png"
              />
              <span>{item.verifiedFixText}</span>
              <span className="name">{item.sellingPoint}</span>
              {renderMore()}
            </div>
          ))}
      </div>
    )
  );
}
